export const isNotNullORBlank = (...args) => {
  for (var i = 0; i < args.length; i++) {
    var argument = args[i];
    if (argument == null || argument == '' || argument == undefined) {
      return false;
    }
  }
  return true;
}

export const isIntersect = (a, b) => {
  const filtered = a.filter(x => b.includes(x));
  return filtered.length > 0;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js